<app-content-card
  [title]="title() | translateLang"
  [useIconSlot]="true"
  [iconBackgroundColor]="'#96080b'"
  [backgroundColor]="backgroundColor()">

  <!-- Header icon -->
  <app-icon
    iconSlot
    name="activity"
    [size]="24"
    [color]="'white'">
  </app-icon>

  <!-- View All button in header right slot -->
  @if (showViewAll() && transactions().length > 0) {
    <a
      rightContent
      class="fund-cash-summary__view-all"
      [routerLink]="viewAllUrl()"
      (click)="onViewAllClick()">
      {{ 'fund.cash_summary.view_all' | translateLang }}
    </a>
  }

  <!-- Transaction list in body -->
  <div class="fund-cash-summary">
    <!-- Column headers -->
    @if (transactions().length > 0) {
      <div class="fund-cash-summary__header">
        <span class="fund-cash-summary__header-label">{{ 'fund.cash_summary.type_of_transaction' | translateLang }}</span>
        <span class="fund-cash-summary__header-label fund-cash-summary__header-label--right">{{ 'fund.cash_summary.amount' | translateLang }}</span>
      </div>
    }

    <!-- Transaction rows -->
    <div class="fund-cash-summary__transactions">
      @for (transaction of transactions(); track transaction.internalId + '_' + $index) {
        <div
          class="fund-cash-summary__row"
          [attr.data-transaction-id]="transaction.internalId">

          <!-- Left side: Icon + Label -->
          <div class="fund-cash-summary__left">
            <div
              class="fund-cash-summary__icon"
              [class.fund-cash-summary__icon--positive]="isPositiveTransaction(transaction.amount)"
              [class.fund-cash-summary__icon--negative]="!isPositiveTransaction(transaction.amount)">
              <app-icon
                name="contribute"
                [size]="14">
              </app-icon>
            </div>
            <div class="fund-cash-summary__details">
              <span class="fund-cash-summary__label">{{ getTransactionDisplayText(transaction) | translateLang }}</span>
              <span class="fund-cash-summary__date fund-cash-summary__date--mobile">
                {{ formatDate(transaction.completedOnString) }}
              </span>
            </div>
          </div>

          <!-- Right side: Amount + Date -->
          <div class="fund-cash-summary__right">
            <span
              class="fund-cash-summary__amount"
              [class.fund-cash-summary__amount--positive]="isPositiveTransaction(transaction.amount)"
              [class.fund-cash-summary__amount--negative]="!isPositiveTransaction(transaction.amount)">
              {{ formatAmount(transaction.amount, transaction.currency) }}
            </span>
            <span class="fund-cash-summary__date fund-cash-summary__date--desktop">
              {{ formatDate(transaction.completedOnString) }}
            </span>
          </div>
        </div>
      } @empty {
        <!-- Empty State -->
        <div class="fund-cash-summary__empty">
          <div class="fund-cash-summary__empty-icon-container">
            <app-icon
              name="empty-document"
              [size]="48"
              [color]="'#9CA3AF'">
            </app-icon>
          </div>
          <h3 class="fund-cash-summary__empty-title">
            {{ 'fund.cash_summary.empty.title' | translateLang }}
          </h3>
          <p class="fund-cash-summary__empty-description">
            {{ 'fund.cash_summary.empty.description' | translateLang }}
          </p>
        </div>
      }
    </div>

    <!-- Footer with disclaimer and badge -->
    @if (transactions().length > 0) {
      <div class="fund-cash-summary__footer">
        <app-badge
          variant="date-range"
          [label]="dateRangeText() | translateLang">
        </app-badge>
        <p class="fund-cash-summary__disclaimer">
          {{ disclaimerText() | translateLang }}
          <a
            class="fund-cash-summary__activity-link"
            [routerLink]="viewAllUrl()"
            (click)="onActivityLinkClick()">
            {{ activityLinkText() | translateLang }}
          </a>.
        </p>
      </div>
    }
  </div>
</app-content-card>